<template>
  <!--其他选项表单-->
  <div class="otherBox">
    <el-form ref="testform" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="机构全称" prop="name">
        <el-input v-model="form.name" style="width:400px" placeholder="机构全称"></el-input>
      </el-form-item>
      <el-form-item label="机构地址" prop="address">
        <dataTree @change='changeId' :defaultData='defaultPointerData'></dataTree>
        <el-input v-model="form.address" style="width:400px;display:block;margin-top:22px" placeholder="街道详细地址"></el-input>
      </el-form-item>
      <el-form-item label="联系人" label-width="120px" prop="linkMan">
        <el-input v-model="form.linkMan" placeholder="联系人名称" class="input-w180"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" label-width="120px" prop="phone">
        <el-input v-model="form.phone" placeholder="联系人电话" class="input-w180"></el-input>
      </el-form-item>
      <el-form-item label="中心坐标" label-width="120px" prop="latitude">
        <el-button @click="showMap.state = true">地图选点</el-button>
        <span style="margin-left: 5px">东经：{{form.longitude | formatDegree}}，北纬：{{form.latitude | formatDegree}}</span>
<!--        <el-input style="width:150px" v-model.number="form.longitude" placeholder="经度"></el-input>-->
<!--        <el-input style="width:150px" v-model.number="form.latitude" placeholder="纬度"></el-input>-->
        <mapPointer :show="showMap" :source='{lat:form.latitude,lng:form.longitude}' @change="confirm"></mapPointer>
      </el-form-item>
      <el-form-item label="所属区划">
        <scaleRegion ref="scaleRegiondata" :isUpdata='isUpdata' :defaultObj='defaultObj' @change="changeRegion" @changeIdval="changeRegionId"></scaleRegion>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import mapPointer from "../../view/component/MapPointer.vue";
import scaleRegion from "../../components/region/ScaleRegion";
import dataTree from "../../view/component/Datatree.vue";
import company from "../../data/basic/plan/company.js";
import { mapState } from "vuex";
export default {
    components: {
        mapPointer,
        dataTree,
        scaleRegion
    },
    data() {
        return {
            // 经纬度
            latitude: "",
            longitude: "",
            showMap: {
                state: false
            },
            defaultObj: {},
            latlng: {
                lat: "",
                lng: ""
            },
            // 验证
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入机构全称的名称",
                        trigger: "blur"
                    }
                ],
                address: [
                    {
                        required: true,
                        message: "请输入街道详细地址",
                        trigger: "blur"
                    }
                ],
                linkMan: [
                    {
                        required: true,
                        message: "请输入联系人的名称",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入联系电话",
                        trigger: "blur"
                    },
                    {
                        pattern: /^1\d{10}$/,
                        message: "手机号格式错误",
                        trigger: "blur"
                    }
                ],
                latitude: [
                    {
                        type: "number",
                        required: true,
                        message: "请选择地图坐标",
                        trigger: "change"
                    }
                ]
            },
            form: {
                linkMan: "",
                address: "",
                city: "",
                cityName: "",
                count: "",
                county: "",
                countyName: "",
                createtime: "",
                id: "",
                latitude: "",
                longitude: "",
                name: "",
                phone: "",
                province: "",
                provinceName: "",
                regionType: 1,
                regions: [],
                role: 1, // 我的角色,0=管理员，1=普通用户 ,
                type: "",
                imgName: ""
            },
            defaultPointerData: [],
            //区域检验结果
            validRegion:false,
        };
    },
    props: {
        // modifyenf: {
        //   type: Object
        // },
        isUpdata: {
            type: Boolean
        }
    },
    computed: {
        ...mapState({
            dataotherlist(state) {
                return state.dataotherlist;
            }
        })
    },
    // 初始化修改数据
    created() {
        if (this.isUpdata) {
            if (!this.dataotherlist) {
                this.$router.replace("/");
            } else {
                this.form = JSON.parse(JSON.stringify(this.dataotherlist));
                let formdata = this.dataotherlist;
                this.defaultPointerData = [
                    this.form.province,
                    this.form.city,
                    this.form.county
                ];

                if (this.dataotherlist.regionType === 3) {
                    this.defaultObj = {
                        regionType: this.dataotherlist.regionType,
                        regions: this.dataotherlist.regions
                    };
                } else {
                    this.defaultObj = {
                        city: this.dataotherlist.regions[0].city,
                        county: this.dataotherlist.regions[0].county,
                        regionType: this.dataotherlist.regionType
                    };
                }
            }
        }
    },
    mounted() {
        // 初始化区县列表
        this.getCountyList();
    },
    methods: {
        // 获取三级联动的ID
        // Name
        changeId(val) {
      if (val.length === 2) {
        this.form.county = ''
        this.form.city = val[1]
        this.form.province = val[0]
      } else {
        this.form.county = val[2]
        this.form.city = val[1]
        this.form.province = val[0]
      }
        },
        changeRegionId(val) {
            this.form.regionType = val;
            // console.log(this.form.regionType, 11111111)
        },
        // 获取所属区划数据
        changeRegion(data, regionId) {
            this.form.regions = data;
        },
        changeRegion(data) {
            this.form.regions = data
            if (this.form.regionType === 3) {
                if (this.form.regions && this.form.regions.length > 1) {
                if (this.form.regions && this.form.regions.length >= 2 && this.form.regions[1].city.code === '') {
                    this.$message.error('跨市类型必须输入2条及以上信息')
                    this.validRegion = false;
                    return;
                }
                } else {
                this.$message.error('跨市类型必须输入2条及以上信息')
                this.validRegion = false;
                return;
                }
            } else {
                if (this.form.regions && this.form.regions[0].city.code === '') {
                this.$message.error('单个区县类型不能为空')
                this.validRegion = false;
                return
                }
            }
            this.validRegion = true;
        },
        // 提交表单
        onSubmitother() {
            this.$refs["scaleRegiondata"].get_datalist();
            if(this.validRegion){
                this.$refs["testform"].validate(valid => {
                    if (valid) {
                        this.$emit("change", this.form);
                    } else {
                        console.log("错误 submit!!");
                        return false;
                    }
                });
            }
        },
        // 取消输入的
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        // 经纬度
        mapclick(val) {
            let lat = val.latlng.lat,
                lng = val.latlng.lng;
            this.latlng.lat = lat;
            this.latlng.lng = lng;
        },
        // 执行确认操作
        confirm(val) {
            this.form.latitude = Math.floor(val.lat * 1000000) / 1000000;
            this.form.longitude = Math.floor(val.lng * 1000000) / 1000000;
        },
        // 执行取消或者关闭
        cancel(val) {
            this.showMap.state = val;
        },
        // 树形数据变化监听
        regionChange() {
            // console.log("监听的数据");
        },
        // 获取区县列表
        getCountyList() {
            (async () => {
                this.statelist = await company.get_tree();
                this.pro = this.statelist;
                this.city = this.pro[0]["children"];
                this.county = this.city[0]["children"];
            })();
        }
    }
};
</script>
<style lang="stylus" scoped>
.otherBox {
  clear: both;
  padding-bottom: 20px;
}

.address-p1 {
  display: block;
  width: 400px;
}

.address-p2 {
  display: block;
  width: 400px;
}

.input-w180 {
  width: 180px;
}

.input-w140 {
  width: 140px;
}

.input-w150 {
  width: 140px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// Otherform.vue?15893772